import FirebaseImage from './FirebaseImage'

export default FirebaseImage



// WEBPACK FOOTER //
// ./src/components/FirebaseImage/index.js